// src/context/NotaireContext.jsx
import { createContext, useContext } from "react";

export const NotaireContext = createContext(null);

export const useNotaire = () => useContext(NotaireContext);

